export default __webpack_public_path__ + "media/images/icons/warning-2adf02afae3f3c507d31e68f6e9fd032.svg";